import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import SIF from "./pages/SIF";
import Disclaimers from "./pages/Disclaimers";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookie from "./pages/Cookie";
import CommissionDisclosure from "./pages/CommissionDisclosure";
import Contact from "./pages/Contact";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/sif" element={<SIF />} />
          <Route path="/disclaimers" element={<Disclaimers />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookie-policy" element={<Cookie />} />
          <Route path="/commission-disclosure" element={<CommissionDisclosure />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <CookieBanner />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;